import "./NotesView.scss";

import React, {FC, useEffect, useRef} from "react";
import {shallowEqual} from "react-redux";
import {Tab, Tabs} from "@mui/material";
import {NotesLocation} from "../../locations/NotesLocation";
import {StackPanel} from "../panels/StackPanel";
import {EditNoteDialog} from "./EditNoteDialog";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {NotePageContextMenu} from "./NotePageContextMenu";
import {NotePageDto} from "../../domain/NotePageDto";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {NotesActions} from "../../redux/NotesSlice";

export const NotePageTabs: FC = () => {
    const parentSection = useAppSelector(s => s.notesState.selectedSection, shallowEqual);
    const pages = useAppSelector(s => s.notesState.searchResultPages?.filter(page => page.ClientSectionId === s.notesState.selectedSectionClientId) ?? s.notesState.pages, shallowEqual);
    const selectedPageClientId = useAppSelector(s => s.notesState.selectedPageClientId, shallowEqual);

    const hasSearchResults = useAppSelector(s => !!s.notesState.searchResultPages);

    const menuRef = useRef<HTMLDivElement>(null);

    const dispatch = useAppDispatch();

    function onAddNotePage() {
        if (parentSection) {
            dispatch(NotesActions.addNotePage(parentSection));
        }
    }

    function onNotePageChange(clientId: string) {
        NotesLocation.selectPageByClientId(clientId);
    }

    function onSetContextPage(page: NotePageDto | undefined) {
        if (page) {
            dispatch(NotesActions.setNotePageContextMenu(page));
        }
    }

    function renderNotePageTab(page: NotePageDto) {
        return (
            <Tab className="selectable"
                 key={page.ClientSectionId + "_" + page.ClientId}
                 value={page.ClientId}
                 label={page.Name}
                 onContextMenu={() => onSetContextPage(page)}/>
        );
    }

    const selectedPageExists = !!pages.find(s => s.ClientId === selectedPageClientId);

    useEffect(() => {
        if (pages.length && !selectedPageExists) {
            NotesLocation.selectPageByClientId(pages[0].ClientId!);
        }
    }, [pages, selectedPageExists]);

    return (
        <>
            <StackPanel className="notes-page-tabs" orientation="horizontal">
                {!hasSearchResults && <Tab className="selectable add-item"
                                             title="Add Page"
                                             value={-1}
                                             icon={<AddBoxIcon/>}
                                             onClick={onAddNotePage}
                />}
                <Tabs ref={menuRef}
                      variant="scrollable"
                      indicatorColor="secondary"
                      textColor="inherit"
                      value={selectedPageExists ? selectedPageClientId : pages[0]?.ClientId ?? ""}
                      onChange={(e, newValue) => onNotePageChange(newValue)}
                >
                    {hasSearchResults && !pages.length
                        ? <Tab label="No pages found" value="" disabled/>
                        : pages.map(renderNotePageTab)}
                </Tabs>
            </StackPanel>
            <NotePageContextMenu elementRef={menuRef}/>

            <EditNoteDialog/>
        </>
    );
};
